import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/shared/service/app-config.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LayoutComponent } from 'src/app/layout/layout.component';

@Component({
  selector: 'app-wmsm-role-management',
  templateUrl: './wmsm-role-management.component.html',
  styleUrls: ['./wmsm-role-management.component.scss']
})
export class WmsmRoleManagementComponent implements OnInit {

  idmUrl: SafeResourceUrl;

  constructor(
    private LayoutComponent: LayoutComponent,
    private ConfigService: AppConfigService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.LayoutComponent.geturl();
    const supportLanguage = ['zh-CN', 'zh-TW', 'en-US'];
    let language = localStorage.getItem("wmsmlang");
    if (language == null || language == undefined || language == '' || supportLanguage.indexOf(language) == -1) {
      language = 'en-US';
    }

    const clientCode = this.ConfigService.getActualConfig('idmConfig.CLIENT_ID');
    const url = this.ConfigService.getActualConfig('idmConfig.IDM_URL') + `/#/v2/role?clientCode=${clientCode}&lang=${language}`;
    this.idmUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
